var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['base-checkbox', _vm.noMarginTop && 'no-margin-top']},[_c('v-checkbox',{attrs:{"width":"5","height":"5","hide-details":"","value":_vm.value,"input-value":_vm.value,"color":_vm.primaryViolet,"rules":_vm.required ? _vm.checkboxRules : []}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }